import React from 'react';
import { CircularProgress, Typography, useTheme } from '@mui/material';
import useStyles from './styles';

export default function LoadingAvatar(props: { loading: boolean, customLogo?: string }) {
  const { loading, customLogo } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [loadingTextVariant, setLoadingTextVariant] = React.useState(true);
  React.useEffect(() => {
    if (loading) {
      const interval = setInterval(() => setLoadingTextVariant((o) => !o), 10000);
      return () => {
        clearInterval(interval);
      };
    }
    return undefined;
  }, [loading]);
  return (
    <div style={{ textAlign: 'center' }}>
      {customLogo && (
      <object
        className={classes.loadingAvatar}
        data={customLogo}
        height="30px"
        aria-labelledby="loading logo"
      />
      )}
      <Typography
        variant="body1"
        color="success"
        component="div"
        fontStyle="italic"
        width={250}
        height={50}
        style={{
          marginBlock: 10, display: 'flex', alignItems: 'center', placeContent: 'center',
        }}
      >
        {' '}
        {loadingTextVariant
          ? <span>Estamos consultando tus datos...</span>
          : (
            <span>
              Este proceso puede durar unos minutos...
            </span>
          )}
      </Typography>
      <CircularProgress
        style={{
          color: loadingTextVariant ? undefined : theme.palette.secondary.main,
          transition: '5s',
          animationDuration: '5s',
        }}
        size={25}
      />
    </div>
  );
}

LoadingAvatar.defaultProps = {
  customLogo: undefined,
};
